import { render, staticRenderFns } from "./NewickTree.vue?vue&type=template&id=c834c3d2&scoped=true&"
import script from "./NewickTree.vue?vue&type=script&lang=js&"
export * from "./NewickTree.vue?vue&type=script&lang=js&"
import style0 from "./NewickTree.vue?vue&type=style&index=0&id=c834c3d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c834c3d2",
  null
  
)

export default component.exports